import type { TCommonParams } from '@cockpitai/integration/panels/types'
import { createContext } from 'react'

export const PanelFilterExtrasContext = createContext<Partial<TCommonParams>>({})

export function PanelFilterExtrasProvider({
  value,
  children,
}: {
  value: Partial<TCommonParams>
  children: React.ReactNode
}) {
  return (
    <PanelFilterExtrasContext.Provider value={value}>
      {children}
    </PanelFilterExtrasContext.Provider>
  )
}
